<template>
	<card :header="false" title="Calories & Pedometer" icon="calories">
		<div class="sk-group sk-group-column" v-if="hasData">
			<div class="sk-group-l sk-group-border-right">
				<h1 class="sk-header-title">Pedometer</h1>
				<div><span class="sk-value-highlight"><b>{{ dataCalories.last }}</b></span><span class="sk-title">Steps</span></div>
			</div>
			<div class="sk-group-l">
				<h1 class="sk-header-title">Calories</h1>
				<div><span class="sk-value-highlight"><b>{{ dataPedometer.last }}</b></span><span class="sk-title">Calories</span></div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
		<template v-slot:more-options>
			<card-option-item-link route="WatchBiometricView" :args="{ watch_id: patient.id, type: 'calories' }" :title="$t('See More')" />
		</template>
	</card>
</template>

<script>
import CardOptionItemLink from '@/modules/common/CardOptionItemLink'
import { mapGetters } from 'vuex'
import Card from '@/modules/common/Card'
import Datetime from '@/utils/Datetime'
export default {
	name: 'card-pacient-calories-pedometer',
	components: {
		Card,
		CardOptionItemLink
	},
	props: {
		patient: {
			type: Object,
			default: () => ({})
		},
		datetime: {
			type: Object,
			default: () => ({
				minute: 0,
				hour: 0,
				day: 0,
				month: 0,
				year: 0
			})
		}
	},
	data() {
		return {
			type: {
				calories: 6,
				pedometer: 7
			},
			default: {},
			readings: {
				calories: [],
				pedometer: []
			}
		}
	},
	computed: {
		hasData: function() {
			return this.readings.calories.length > 0 && this.readings.pedometer.length > 0
		},
		dataCalories: function() {
			const list  = this.readings.calories
			if (list.length === 0)
				return this.default
			const reading = list.sort((a1, a2) => a1.key - a2.key)[0]
			return reading.single
		},
		dataPedometer: function() {
			const list  = this.readings.pedometer
			if (list.length === 0)
				return this.default
			const reading = list.sort((a1, a2) => a1.key - a2.key)[0]
			return reading.single
		},
		...mapGetters({
			getPatientByType: 'PATIENTS_READINGS_BY_TYPE'
		}),
	},
	methods: {
		refresh() {
			this.readings.calories = this.getPatientByType(this.patient, this.type.calories, Datetime.toKey(this.datetime))
			this.readings.pedometer = this.getPatientByType(this.patient, this.type.pedometer, Datetime.toKey(this.datetime))
		}
	},
	watch: {
		datetime(newValue, oldValue) {
			this.refresh()
		}
	},
	created() {
		this.refresh()
	}
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientCaloriesPedometer.vue